import { render, staticRenderFns } from "./OrderHousing.vue?vue&type=template&id=182ecf52&scoped=true"
import script from "./OrderHousing.vue?vue&type=script&lang=js"
export * from "./OrderHousing.vue?vue&type=script&lang=js"
import style0 from "./OrderHousing.vue?vue&type=style&index=0&id=182ecf52&prod&lang=scss&scoped=true"
import style1 from "./OrderHousing.vue?vue&type=style&index=1&id=182ecf52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182ecf52",
  null
  
)

export default component.exports